import { useMutation } from '@tanstack/react-query';

import { supabaseClient } from 'src/auth/supabase';

export const useLogoutSupabase = (onSuccessCallback: () => void) =>
    useMutation<unknown, Error>({
        mutationKey: ['auth', 'signOut'],
        mutationFn: async () => {
            const res = await supabaseClient.auth.signOut({ scope: 'local' });

            if (res.error) throw res.error;
        },

        onSuccess: () => {
            onSuccessCallback();
        },
    });
